var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainNavReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/reports") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 2a1.6 1.6 0 0 0-1.416 2.345l-1.368 1.711a1.6 1.6 0 0 0-1.44.317l-2.18-1.09A1.6 1.6 0 0 0 10 5.2a1.6 1.6 0 1 0-3.197.083L4.625 6.372a1.6 1.6 0 1 0 .572 1.145l2.178-1.089a1.6 1.6 0 0 0 2.05 0l2.18 1.09a1.6 1.6 0 0 0-.005.082 1.6 1.6 0 1 0 3.016-.744l1.368-1.71A1.6 1.6 0 1 0 16.4 2zm0 8.8a1.6 1.6 0 0 0-1.437 2.3l-1.366 1.752a1.6 1.6 0 0 0-1.142.133l-1.71-1.37A1.6 1.6 0 0 0 9.2 11.6a1.6 1.6 0 0 0-1.583 1.386l-2.784.795a1.6 1.6 0 1 0 .35 1.233l2.784-.795a1.6 1.6 0 0 0 1.977.397l1.71 1.368a1.6 1.6 0 1 0 2.952-.347l1.332-1.706A1.6 1.6 0 1 0 16.4 10.8z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNavReports);
export default __webpack_public_path__ + "static/media/main-nav-reports.7ac55592307d79fdc129d8a24e5cf4cc.svg";
export { ForwardRef as ReactComponent };